<template>
    <div class="files">
        <div class="row">
            <div v-if="files.length" class="col-default-12 files__container">
                <z-filelist>
                    <div class="files__item">
                        <z-filelist-item
                            v-for="(file, index) in files"
                            :key="index"
                            :icon="`file/${file.file.type}`"
                            :info="file.file.size"
                            :date="getFileDate(file.activeFrom) || null"
                        >
                            <z-link :href="file.file.link"> {{ file.name }} </z-link>
                        </z-filelist-item>
                    </div>
                </z-filelist>
            </div>

            <div v-if="foldersWithFiles.length" class="col-default-12">
                <z-accordion>
                    <z-accordion-item
                        v-for="(folder, index) in foldersWithFiles"
                        :key="index"
                        :id="`${type}-${folder.code}`"
                    >
                        <template v-slot:header>
                            <span>{{ folder.name }}</span>
                        </template>
                        <template v-slot:body>
                            <z-filelist>
                                <div class="files__item">
                                    <z-filelist-item
                                        v-for="(file, index) in folder.items"
                                        :key="index"
                                        :icon="`file/${file.file.type}`"
                                        :info="file.file.size"
                                        :date="getFileDate(file.activeFrom) || null"
                                    >
                                        <z-link :href="file.file.link"> {{ file.name }} </z-link>
                                    </z-filelist-item>
                                </div>
                            </z-filelist>
                        </template>
                    </z-accordion-item>
                </z-accordion>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'

export default {
    name: 'files-page',
    props: {
        source: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: ''
        }
    },

    data () {
        return {
            files: [],
            foldersWithFiles: []
        }
    },

    created () {
        try {
            if (this.$root.app.components[this.source]) {
                if (this.type.length > 0) {
                    this.files = this.$root.app.components[this.source][this.type].items
                    this.foldersWithFiles = this.$root.app.components[this.source][this.type]['items-with-tabs']
                } else {
                    this.files = this.$root.app.components[this.source].items
                    this.foldersWithFiles = this.$root.app.components[this.source]['items-with-tabs']
                }
            }
        } catch (error) {
            console.log(error)
        }
    },

    methods: {
        getFileDate (date) {
            if (date) {
                return moment.unix(date).format('LL')
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.files {
    &__container {
        margin-bottom: 64px;
    }

    &__item {
        .z-list-item {
            padding-bottom: 32px;
            margin-bottom: 32px;

            &:not(:last-child) {
                border-bottom: 1px solid $token-colors-tertiary-15;
            }
        }
    }
}
</style>
